import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import { Texterror } from "../../../../constants/Texterror";
import { getSession } from "../../../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import {
  addPatients,
  editPatient,
} from "../../../../redux/actions/dbactions/pateints";
import { refTypesList } from "../../../../redux/actions/dbactions/refactions";
import { patientForm } from "../../../../constants/Validation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Header } from "../../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Autocomplete, LoadScriptNext } from "@react-google-maps/api";

const PatientProfileForm = () => {
  const autocompleteRef = useRef();
  const { role_id, user_profile_id } = getSession();
  const dispatch = useDispatch();
  const { refsdata } = useSelector((state) => state.refstypes);
  const history = useHistory();
  const location = useLocation();

  const [countrySName, setCountrySName] = useState("");

  const initialPatientData = location.state?.patientData || {
    svcuser_profile_id: "",
    user_first_name: "",
    user_last_name: "",
    user_phone_nbr: "",
    addr_street1: "",
    addr_street2: "",
    addr_zipcode: "",
    addr_state: "",
    ethncty_id: "",
    gender_id: "",
    svcf_allow_sms_yn: "N",
    svcf_allow_wup_sms_yn: "N",
    iso_cntry_id: "",
    iso_cntry_name: "",
    iso_city_id: "",
    city: "",
    country: "",
  };
  initialPatientData.city = initialPatientData.user_iso_city_name;
  initialPatientData.country = initialPatientData.user_iso_cntry_name;
  useEffect(() => {
    dispatch(refTypesList());
  }, [dispatch]);

  const handleedit = (values) => {
    const updatedValues = {
      ...values,
      addr_state: values.addr_zipcode,
      addr_iso_city_id: values.iso_city_id,
      addr_country_id: values.iso_cntry_id,
      svcuser_reqstr_user_id: user_profile_id,
      sys_user_id: user_profile_id,
      role_id: role_id,
      iso_cntry_2_cde: countrySName,
    };
    initialPatientData.svcuser_profile_id
      ? dispatch(
          editPatient(updatedValues, initialPatientData.svcuser_profile_id)
        )
      : dispatch(addPatients(updatedValues));
  };

  const ethnicitys = refsdata.usr?.ethnicity || [];
  const genders = refsdata.usr?.gender || [];

  const handleEthinicity = (event, setFieldValue) => {
    const selectedEthnicity = event.target.value;
    setFieldValue("ethncty_id", selectedEthnicity);
  };

  const handleGender = (event, setFieldValue) => {
    const selectedGender = event.target.value;
    setFieldValue("gender_id", selectedGender);
  };

  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API;

  const handlePlaceSelected = (setFieldValue) => {
    const place = autocompleteRef.current.getPlace();

    if (place) {
      const addressComponents = place.address_components;

      const extractComponent = (type) =>
        addressComponents?.find((comp) => comp.types.includes(type))
          ?.long_name || "";
      const countryShortName = addressComponents.find((component) =>
        component.types.includes("country")
      )?.short_name;
      setFieldValue("addr_street1", place.name);
      //setFieldValue("addr_street2", place?.formatted_address);
      setFieldValue("addr_zipcode", extractComponent("postal_code"));
      setFieldValue("city", extractComponent("locality"));
      setFieldValue("country", extractComponent("country"));
      setCountrySName(countryShortName);
      const countryName = extractComponent("country");
      setFieldValue("iso_cntry_name", countryName);
    }
  };

  return (
    <div className="profile">
      <Header
        pageTitle="Patient Profile > Add New Patient"
        icon={<Icon icon="fa-solid:user-injured" />}
      />
      <div className="card_white_box">
        <h5 className="globale-title">
          <span>Patient Profile</span>
        </h5>
        <LoadScriptNext
          googleMapsApiKey={GOOGLE_API_KEY}
          libraries={["places"]}
        >
          <Formik
            initialValues={initialPatientData}
            validationSchema={patientForm}
            onSubmit={(values, action) => {
              const dataToSend = {
                ...values,
                iso_cntry_name: undefined,
              };
              action.resetForm();
              action.setSubmitting(false);
              handleedit(dataToSend);
              history.goBack();
            }}
          >
            {({
              touched,
              errors,
              values,
              handleSubmit,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit} className="md:px-14">
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Field
                        placeholder="First Name"
                        className={`form-control ${
                          touched.user_first_name && errors.user_first_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_first_name"
                        type="input"
                        value={values.user_first_name}
                      />
                      <ErrorMessage
                        name="user_first_name"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.user_last_name && errors.user_last_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_last_name"
                        type="input"
                        value={values.user_last_name}
                        placeholder="Last Name"
                      />
                      <ErrorMessage
                        name="user_last_name"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Phone Number(pick country first)</Form.Label>
                      <PhoneInput
                        country={"zw"}
                        value={values.user_phone_nbr}
                        onChange={(phone) =>
                          setFieldValue("user_phone_nbr", phone)
                        }
                        enableAreaCodes={true}
                        enableSearch={true}
                        disableSearchIcon={true}
                        autoFormat={false}
                        name="user_phone_nbr"
                        inputClass={`form-control ${
                          touched.user_phone_nbr && errors.user_phone_nbr
                            ? "is-invalid"
                            : ""
                        }`}
                      />

                      <ErrorMessage
                        name="user_phone_nbr"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Ethnicity</Form.Label>
                      <Form.Select
                        className="form-control"
                        name="ethncty_id"
                        aria-label="Default select example"
                        onChange={(e) => handleEthinicity(e, setFieldValue)}
                        value={values.ethncty_id}
                      >
                        <option>Select Ethnicity</option>
                        {ethnicitys.map((item) => (
                          <option key={item.ethncty_id} value={item.ethncty_id}>
                            {item.ethncty_desc}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage name="ethncty_id" component={Texterror} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        className="form-control"
                        name="gender_id"
                        aria-label="Default select example"
                        onChange={(e) => handleGender(e, setFieldValue)}
                        value={values.gender_id}
                      >
                        <option>Select Gender</option>
                        {genders.map((item, index) => (
                          <option key={item.gender_id} value={item.gender_id}>
                            {item.gender_desc}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage name="gender_id" component={Texterror} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Label>Address</Form.Label>
                    <div className="mb-3">
                      <Autocomplete
                        onLoad={(autocomplete) =>
                          (autocompleteRef.current = autocomplete)
                        }
                        onPlaceChanged={() =>
                          handlePlaceSelected(setFieldValue)
                        }
                      >
                        <Field
                          className={`form-control ${
                            touched.addr_street1 && errors.addr_street1
                              ? "is-invalid"
                              : ""
                          }`}
                          name="addr_street1"
                          type="text"
                          placeholder="Enter your address"
                          value={values.addr_street1}
                        />
                      </Autocomplete>
                      <ErrorMessage name="addr_street1" component={Texterror} />
                    </div>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${
                          touched.addr_street2 && errors.addr_street2
                            ? "is-invalid"
                            : ""
                        }`}
                        name="addr_street2"
                        type="input"
                        value={values.addr_street2}
                        placeholder="Address line 2"
                      />
                      <ErrorMessage name="addr_street2" component={Texterror} />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Country</Form.Label>

                      <Field
                        className={`form-control ${
                          touched.country && errors.country ? "is-invalid" : ""
                        }`}
                        name="country"
                        type="text"
                        placeholder="Enter country"
                        value={values.country}
                      />
                      <ErrorMessage name="country" component={Texterror} />
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3 position-relative">
                      <Form.Label>City</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.city && errors.city ? "is-invalid" : ""
                        }`}
                        name="city"
                        type="text"
                        placeholder="Enter city"
                        value={values.city}
                      />

                      <ErrorMessage name="city" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Zip Code(optional)</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.addr_zipcode && errors.addr_zipcode
                            ? "is-invalid"
                            : ""
                        }`}
                        name="addr_zipcode"
                        placeholder="Optional Zip Code"
                        type="input"
                        value={values.addr_zipcode}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="flex mb-2 items-center gap-2">
                      <FormCheck
                        name="svcf_allow_sms_yn"
                        id="svcf_allow_sms_yn"
                        checked={values.svcf_allow_sms_yn === "Y"}
                        type="checkbox"
                        onChange={(e) => {
                          setFieldValue(
                            "svcf_allow_sms_yn",
                            e.target.checked ? "Y" : "N"
                          );
                        }}
                      />
                      <label
                        className="cursor-pointer"
                        htmlFor="svcf_allow_sms_yn"
                      >
                        Yes, contact me via SMS
                      </label>
                    </div>
                    <div className="flex mb-2 items-center gap-2">
                      <FormCheck
                        name="svcf_allow_wup_sms_yn"
                        id="svcf_allow_wup_sms_yn"
                        checked={values.svcf_allow_wup_sms_yn === "Y"}
                        type="checkbox"
                        onChange={(e) => {
                          setFieldValue(
                            "svcf_allow_wup_sms_yn",
                            e.target.checked ? "Y" : "N"
                          );
                        }}
                      />
                      <label
                        className="cursor-pointer"
                        htmlFor="svcf_allow_wup_sms_yn"
                      >
                        <span
                          style={{
                            fontWeight:
                              values.svcf_allow_wup_sms_yn === "Y"
                                ? "normal"
                                : "bold",
                            color:
                              values.svcf_allow_wup_sms_yn === "Y"
                                ? "black"
                                : "red",
                          }}
                        >
                          Yes, contact me via Whatsapp
                        </span>
                      </label>
                    </div>
                    <div className="mini_edit justify-end">
                      <Button
                        className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                        variant="secondary"
                        onClick={() => history.goBack()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        +Submit
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </LoadScriptNext>
      </div>
    </div>
  );
};

export default withRouter(PatientProfileForm);
